<template>
    <div>
        <div class="material" v-if="!deleted">
            <b-row>
                <b-col cols="7">
                    <h6 class="mb-1"><i class="far fa-file fa-fw mr-2"></i>{{material.title}}</h6>
                    <div class="date"><i class="far fa-fw mr-2"></i><span>{{material.name}}, {{material.created_at | moment('MMM D, YYYY')}}</span></div>
                    <div class="desc" v-if="material.description"><i class="far fa-fw mr-2"></i><span>{{material.description}}</span></div>
                </b-col>
                <b-col class="text-right">
                    <b-button variant="outline-warning" size="sm" class="mr-2" @click="deleteFile()"><i class="fas fa-times"></i></b-button>
                    <b-button variant="outline-success" size="sm" class="mr-2" target="_blank" :href="apiUrl + 'api/session/' + session.id + '/download/' + material.file"><i class="fas fa-download"></i></b-button>
                    <b-button variant="success" size="sm" v-b-modal="'editFile' + material.id"><i class="fas fa-pencil mr-2"></i> Edit</b-button>
                </b-col>
            </b-row>
        </div>

        <b-modal :id="'editFile' + material.id" :ref="'editFile' + material.id" hide-footer hide-header-close>
            <template v-slot:modal-title>
                Edit File Details
            </template>

            <div>
                <b-form>
                    <b-form-row>
                        <b-col>
                            <b-form-group>
                                <label>File Name <span class="required">*</span></label>
                                <b-form-input v-model="material.name"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col>
                            <label>Title <span class="required">*</span></label>
                            <b-form-input v-model="material.title"></b-form-input>
                        </b-col>
                    </b-form-row>
                    <b-form-row class="mt-3">
                        <b-col>
                            <label>Short Description</label>
                            <b-form-textarea v-model="material.description"></b-form-textarea>
                        </b-col>
                    </b-form-row>
                    <b-form-row class="mt-5">
                        <b-col>
                            <b-button variant="success" block @click="updateFile()"><i class="far fa-check mr-2"></i>Update Details</b-button>
                        </b-col>
                    </b-form-row>
                </b-form>
            </div>

        </b-modal>
    </div>

</template>

<script>
    import {mapActions} from 'vuex';
    import {apiUrl} from "../constants/config";

    export default {
        name: "MaterialRow",
        props: ['session', 'material'],
        data: function() {
            return {
                apiUrl: apiUrl,
                deleted: false
            }
        },
        methods: {
            ...mapActions(['deleteSessionFile', 'updateSessionFile']),

            deleteFile: function() {
                if (confirm('Are you sure you want to remove this file? It cannot be recovered once removed.')) {
                    this.deleteSessionFile({id: this.session.id, matId: this.material.id, file: this.material.file}).then(() => {
                        this.deleted = true;
                    });
                }
            },

            updateFile: function() {
                this.updateSessionFile(this.material).then(() => {
                    this.$refs['editFile' + this.material.id].hide();
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .material {
        padding: 1rem;
        margin-bottom: 0.2rem;

        border: 1px solid #eee;
        border-radius: 0.5rem;

        .date span {
            font-size: 0.8rem;
            color: #777;
        }
        .desc span {
            font-size: 0.9rem;
            color: #333;
        }

        .fa-ban {
            color: red !important;
        }
    }
</style>
